const handleScoreChange = (onChange) => (e) => {
  const newScore = parseInt(e.target.value) || 0;
  onChange({ score: newScore });
  return newScore; // Return for components that need local state
};

export { handleScoreChange };
